const searchReducer = (isOpen = false, action) => {
    switch (action.type) {
        case "ACTIVATE_SEARCH":
            return action.payload;
        default:
            return isOpen;
    }
};

export default searchReducer;